import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RentalsService } from '../../../../../../services/rentals.service';
import { CyclistService } from '../../../../../../services/cyclist.service';
import { HelpersService } from '../../../../../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-rental-reservation-update',
  templateUrl: './rental-reservation-update.component.html',
  styleUrls: ['./rental-reservation-update.component.scss'],
})
export class RentalReservationUpdateComponent implements OnInit {
  @Input() reservationSummary;
  @Input() categories;
  @Input() fullAccessoryList = [];
  @Input() brands;
  @Input() sizes;
  @Input() rentalStoreRules;
  @Output() close = new EventEmitter();

  public partnerData: any = {};
  public reservation: any = {};
  public reservationPaymentHistory: any = [];
  public cyclist: any = {};
  public activeItem: MenuItem;
  public selectedTab: number;
  public reservationItems: MenuItem[] = [];
  public affiliates: any = [];

  constructor(
    private rentalsService: RentalsService,
    private helpersService: HelpersService,
    private cyclistService: CyclistService,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.partnerData = this.helpersService.getPartnerData();
    this.reservationItems = [
      {
        label: this.translate.instant('bikeshop.rentals.booking.reservation'),
        command: () => {
          this.selectedTab = 0;
        },
      },
      {
        label: this.translate.instant(
          'bikeshop.modal.update_job_card.tab.quote',
        ),
        command: () => {
          this.selectedTab = 1;
        },
      },
      {
        label: this.translate.instant(
          'bikeshop.modal.update_job_card.tab.messaging',
        ),
        command: () => {
          this.selectedTab = 2;
        },
      },
      // { label: this.translate.instant('bikeshop.modal.update_job_card.tab.checklist'), command: () => { this.selectedTab = 3 } },
      {
        label: this.translate.instant(
          'bikeshop.modal.update_job_card.tab.attachments',
        ),
        command: () => {
          this.selectedTab = 3;
        },
      },
      {
        label: this.translate.instant('bikeshop.rentals.booking.waiver_text'),
        command: () => {
          this.selectedTab = 4;
        },
      },
    ];

    this.activeItem = this.reservationItems[0];
    this.selectedTab = 0;

    this.getReservation();
    this.getReservationPaymentHistory();
    //this.getCyclist();
    this.getAffiliates();

    document.documentElement.style.setProperty('--show-intercom', 'none');
  }

  ngOnDestroy() {
    document.documentElement.style.setProperty('--show-intercom', 'inherit');
  }

  getAffiliates() {
    this.rentalsService
      .getRentalAffiliatesBooking(this.helpersService.getPartnerId())
      .subscribe((affiliates: any) => {
        this.affiliates = affiliates.map((x) => {
          return { value: x.id, label: x.affiliateName };
        });
        this.affiliates.unshift({ value: null });
      });
  }

  getCyclist() {
    /*if (this.reservationSummary.userID) {
      this.cyclistService
        .getCyclistById(this.reservationSummary.userID)
        .subscribe((cyclist) => {
          this.cyclist = cyclist;
        });
    }*/
    this.cyclist = { ID: this.reservation.userID, Name: this.reservation.firstName, Surname: this.reservation.surname, PhoneNumber: this.reservation.phoneNumber, Email: this.reservation.email }
  }

  getReservation() {
    this.rentalsService
      .getRentalReservation(this.partnerData.ID, this.reservationSummary.id)
      .subscribe((reservation) => {
        if(reservation.id === 0){
          this.close.emit();
          return;
        }
        this.updateReservationData(reservation);
        //if(!this.reservationSummary.userID) {
        //this.reservationSummary.userID = reservation.userID;
        //this.reservationSummary.name = reservation.firstName;
        //this.reservationSummary.surname = reservation.surname;
        this.getCyclist();
        //}
      });
  }

  getReservationPaymentHistory() {
    this.rentalsService
      .getRentalReservationPaymentHistory(
        this.partnerData.ID,
        this.reservationSummary.id,
      )
      .subscribe((paymentHistory) => {
        this.updateReservationPaymentData(paymentHistory);
      });
  }

  updateReservationData(reservation) {
    this.reservation = {
      ...reservation,
      fromDate: new Date(reservation.fromDate),
      toDate: new Date(reservation.toDate),
    };
  }

  updateReservationPaymentData(paymentHistory) {
    this.reservationPaymentHistory = paymentHistory;
  }

  reloadReservation(event) {
    this.getReservation();
    this.getReservationPaymentHistory();
  }

  printReservation() {
    var win = window.open(
      `/rentals/print-out/${this.reservation.webIdentifier}`,
      '_blank',
    );
    win.focus();
  }
}
